const STAGE = "stage";
const PRODUCTION = "production";
const DEVELOPMENT = "development";
const MGMTPROD = "management-prod";
const PRODRECOVERY = "prodrecovery";

// determine environment from window.location.origin
function environmentFromOrigin(): string {
  const origin = window.location.origin;
  if (origin === "https://u-stg.cisco.com") {
    return STAGE;
  } else if (origin === "https://u.cisco.com") {
    return PRODUCTION;
  } else if (origin === "https://u-mgmtprod.cisco.com") {
    return MGMTPROD;
  } else if (origin === "https://u-prodrecovery.cisco.com") {
    return PRODRECOVERY;
  }
  return DEVELOPMENT;
}

// setupConfig imports the config file based on the environment and sets the window.env.<key> = value if assignEnv is true.
async function setupConfig(environment: string, assignEnv: boolean = false) {
  let config = {};
  const validEnvironments = [
    DEVELOPMENT,
    PRODUCTION,
    "testing",
    MGMTPROD,
    STAGE,
    PRODRECOVERY,
  ];
  if (!validEnvironments.includes(environment)) {
    return config;
  }

  // import the config file based on the environment
  switch (environment) {
    case DEVELOPMENT:
      // Check if VITE_USE_PROXY is enabled to use staging proxy configuration
      if (import.meta.env.VITE_USE_PROXY === "true") {
        config = await import("../configs/dev-to-stage.json");
      } else {
        config = await import("../configs/dev.json");
      }
      break;
    case STAGE:
      config = await import("../configs/stage.json");
      break;
    case PRODUCTION:
      config = await import("../configs/prod.json");
      break;
    case "testing":
      config = await import("../configs/testing.json");
      break;
    case MGMTPROD:
      config = await import("../configs/management-prod.json");
      break;
    case PRODRECOVERY:
      config = await import("../configs/prodrecovery.json");
      break;
  }

  if (assignEnv) {
    assignWindowEnv(config);
  }

  return config;
}

// iterate over config object and set window.env.<key> = value
function assignWindowEnv(config: { [key: string]: any }) {
  if (window && window?.env === undefined) {
    // @ts-ignore
    window.env = {};
  }
  Object.keys(config).forEach((key) => {
    if (window.env[key as keyof typeof window.env] === undefined) {
      // @ts-ignore
      window.env[key as keyof typeof window.env] =
        config[key as keyof typeof config];
    }
  });
}

export { assignWindowEnv, environmentFromOrigin, setupConfig };
